import {
    Component,
    EventEmitter,
    Output,
    ViewEncapsulation,
    ViewChild,
    OnInit,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LegalDialogComponent } from '../../dialogs/legal-dialog/legal-dialog.component';
import { CreateBusinessAccountFormData } from '../../model/form-data';
import { CreateAddressSectionComponent } from '../create-address-section/create-address-section.component';
import { TaxType } from '@viewbid/ts-angular-client';
import { CreateProfileComponentService } from '../../services/create.profile.component.service';

@Component({
    selector: 'vb-create-business-profile',
    templateUrl: './create-business-profile.component.html',
    styleUrls: ['./create-business-profile.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class CreateBusinessProfileComponent implements OnInit {
    isFormValid = true;
    businessProfileFormGroup = this._formBuilder.group({
        companyName: ['', Validators.required],
        businessRepName: ['', Validators.required],
        hstNumber: ['', Validators.required],
    });

    @Output() submitBusinessProfileFormData =
        new EventEmitter<CreateBusinessAccountFormData>();
    @ViewChild('addressSection')
    private addressSection!: CreateAddressSectionComponent;

    constructor(
        private _formBuilder: FormBuilder,
        private dialog: MatDialog,
        private createProfileComponentService: CreateProfileComponentService,
    ) {}

    ngOnInit(): void {
        this.businessProfileFormGroup.valueChanges.subscribe(() => {
            this.isFormValid = this.validate();
        });
    }

    addressSectionValueChanges(): void {
        this.isFormValid = this.validate();

        this.createProfileComponentService.setFormValidity(this.isFormValid);
    }

    onSubmit(): void {
        this.isFormValid = this.validate();
        if (this.isFormValid) {
            this.submitBusinessProfileFormData.emit({
                name:
                    this.businessProfileFormGroup.controls['companyName']
                        .value ?? '',
                representativeFullName:
                    this.businessProfileFormGroup.controls['businessRepName']
                        .value ?? '',
                taxType: TaxType.Hst,
                businessNumber:
                    this.businessProfileFormGroup.controls['hstNumber'].value ??
                    '',
                postalCode:
                    this.addressSection.addressFormGroup.controls['postalCode']
                        .value,
                city: this.addressSection.addressFormGroup.controls['city']
                    .value,
                country:
                    this.addressSection.addressFormGroup.controls['country']
                        .value,
                address1:
                    this.addressSection.addressFormGroup.controls['address1']
                        .value,
                address2:
                    this.addressSection.addressFormGroup.controls['address2']
                        .value,
                province:
                    this.addressSection.addressFormGroup.controls['province']
                        .value,
                phoneNumber:
                    this.addressSection.addressFormGroup.controls['phoneNumber']
                        .value,
                phoneNumberExt: '',
                buzzer: '',
            });
        }
    }

    validate(): boolean {
        this.addressSection.markAllAsTouched();
        this.businessProfileFormGroup.markAllAsTouched();

        return (
            this.businessProfileFormGroup.valid &&
            this.addressSection.isFormValid()
        );
    }

    openDialog(): void {
        this.dialog.open(LegalDialogComponent);
    }
}
